export default "__VITE_ASSET__d813facd__"